import { Pipe, PipeTransform } from '@angular/core';
import { HtmlEditorVariable, HtmlEditorVariableType } from './html-editor.component';

@Pipe({
  name: 'htmlEditorVariablesSelectBoxItems',
})
export class HtmlEditorVariablesSelectBoxItemsPipe implements PipeTransform {
  transform(variables: HtmlEditorVariable[], selectBoxType: HtmlEditorVariableType): HtmlEditorVariable[] {
    return variables
      ?.map(variable => {
        if (!variable) {
          return null;
        }

        return { ...variable, items: variable?.items?.filter(item => item?.type === selectBoxType) };
      })
      ?.filter(variable => variable?.items?.length);
  }
}
